import { render, staticRenderFns } from "./boardgames.vue?vue&type=template&id=44b120e0"
import script from "./boardgames.vue?vue&type=script&lang=js"
export * from "./boardgames.vue?vue&type=script&lang=js"
import style0 from "./boardgames.vue?vue&type=style&index=0&id=44b120e0&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports